import React from 'react';
// import { reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { Claim, Enumeration } from '../../xmlParsing/interfaces';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import cn from 'clsx';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '0 0.5rem 0.5rem 0.5rem',
      border: '2px solid #010101',
      borderRadius: '2px',
      boxShadow: '5px 5px 5px grey',
      marginBottom: '1rem',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexRowWrap: {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'center',
      alignItems: 'baseline',
      flexWrap: 'wrap',
    },
    flexRowNoWrap: {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'center',
      alignItems: 'baseline',
      flexWrap: 'nowrap',
    },

    flexRowItem: {
      marginLeft: '1rem',
    },
    claimName: {
      fontSize: '2rem',
      color: '#010101',
    },
    indent: {
      marginLeft: '2rem',
    },
    mb1: {
      marginBottom: '1rem',
    },
    subHeading: {
      color: '#010101',
      fontWeight: 600,
      fontSize: '1.1rem',
      marginRight: '0.5rem',
    },
    usePointerCursor: {
      cursor: 'pointer',
    },
  }),
);

interface ShowClaimComponentProps {
  data: Claim;
  editClaim?: any;
}
function ShowClaimComponent({ data, editClaim }: ShowClaimComponentProps) {
  const classes = styles();
  return (
    <>
      {Object.keys(data || {}).length > 0 && (
        <div className={cn(classes.container, classes.flexCol)}>
          <div className={cn(classes.claimName, classes.mb1)}>
            {data['id']}&nbsp;
            {data['userCreated'] && editClaim && (
              <ModeEditOutlineSharpIcon
                className={classes.usePointerCursor}
                onClick={() => {
                  editClaim(data['id']);
                }}
              />
            )}
          </div>
          <div className={cn(classes.flexRowWrap, classes.mb1)}>
            <div className={cn(classes.flexRowNoWrap, classes.flexRowItem)}>
              <div className={classes.subHeading}>Display Name </div>
              <div>{data['displayName'] ? data['displayName'] : data['id']}</div>
            </div>
            <div className={cn(classes.flexRowNoWrap, classes.flexRowItem)}>
              <div className={classes.subHeading}>User Input Type </div>
              <div>{data['userInputType'] ? data['userInputType'] : 'Not set'}</div>
            </div>
            <div className={cn(classes.flexRowNoWrap, classes.flexRowItem)}>
              <div className={classes.subHeading}>Data Type </div>
              <div>{data['dataType']}</div>
            </div>
          </div>
          {data.hasOwnProperty('userHelpText') && data['userHelpText'] != '' && (
            <div className={cn(classes.flexRowNoWrap, classes.mb1)}>
              <div className={cn(classes.flexRowItem, classes.subHeading)}>User Help Text </div>
              <div>{data['userHelpText']}</div>
            </div>
          )}
          {data.hasOwnProperty('adminHelpText') && data['adminHelpText']?.trim() != '' && (
            <div className={cn(classes.flexRowNoWrap, classes.mb1)}>
              <div className={cn(classes.flexRowItem, classes.subHeading)}>Admin Help Text </div>
              <div>{data['adminHelpText']}</div>
            </div>
          )}

          {data.hasOwnProperty('enumeration') && (
            <div className={cn(classes.flexCol, classes.mb1)}>
              <div className={cn(classes.flexRowItem, classes.subHeading)}>Enumeration </div>
              <table className={classes.indent}>
                <tbody>
                  {data['enumeration']?.map((en: Enumeration) => {
                    return (
                      <tr key={en['value']}>
                        <td>
                          <span className={classes.subHeading}>Value </span> {en['value']}
                        </td>
                        <td>
                          <span className={classes.subHeading}>Text </span> {en['text']}
                        </td>
                        <td>
                          <span className={classes.subHeading}>SelectByDefault </span>{' '}
                          {en['selectByDefault'].toString()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {data.hasOwnProperty('pattern') && (
            <div className={cn(classes.flexCol, classes.mb1)}>
              <div className={cn(classes.flexRowItem, classes.subHeading)}>Pattern </div>
              <div className={cn(classes.flexRowNoWrap, classes.indent)}>
                <div className={classes.subHeading}>Regular Expression </div>
                <span>{data?.pattern && data?.pattern['regularExpression']}</span>
              </div>
              <div className={cn(classes.flexRowNoWrap, classes.indent)}>
                <div className={classes.subHeading}>Help Text </div>
                <span>{data?.pattern && data?.pattern['helpText']}</span>
              </div>
            </div>
          )}

          {data.hasOwnProperty('mask') && data?.mask?.type && data.mask.type !== 'None' && (
            <div className={cn(classes.flexCol, classes.mb1)}>
              <div className={cn(classes.flexRowItem, classes.subHeading)}>Mask </div>
              {data?.mask && (
                <>
                  <div className={cn(classes.flexRowNoWrap, classes.indent)}>
                    <div className={classes.subHeading}>Type </div>
                    <span>{data?.mask.type}</span>
                  </div>
                  <div className={cn(classes.flexRowNoWrap, classes.indent)}>
                    <div className={classes.subHeading}>Value </div>
                    <span>{data?.mask && data?.mask['value']}</span>
                  </div>
                  {data?.mask.type === 'Regex' && (
                    <div className={cn(classes.flexRowNoWrap, classes.indent)}>
                      <div className={classes.subHeading}>Regex </div>
                      <span>{data?.mask && data?.mask['regex']}</span>
                    </div>
                  )}
                </>
              )}
              <br />
            </div>
          )}
          <div></div>
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, ShowClaimComponent);
export default ShowClaimComponent;
